import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface PhotoPlaceholderProps {
  title: string;
  subtitle?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const PhotoPlaceholder: React.FC<PhotoPlaceholderProps> = ({ 
  title, 
  subtitle, 
  className = "", 
  size = 'md' 
}) => {
  const getInitials = (text: string) => {
    return text
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const sizeClasses = {
    sm: 'h-24 w-24',
    md: 'h-32 w-32',
    lg: 'h-48 w-48'
  };

  const textSizes = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl'
  };

  return (
    <Card className={`${sizeClasses[size]} ${className} bg-gradient-to-br from-sauna-orange/10 to-sauna-blue/10 border border-sauna-orange/20 flex items-center justify-center relative overflow-hidden`}>
      <CardContent className="p-0 w-full h-full flex flex-col items-center justify-center">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-2 left-2 w-8 h-8 border-2 border-sauna-orange rounded-full"></div>
          <div className="absolute bottom-2 right-2 w-6 h-6 border border-sauna-blue rounded-full"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12 border border-sauna-navy rounded-full"></div>
        </div>
        
        {/* Main Content */}
        <div className="relative z-10 text-center">
          <div className={`${textSizes[size]} font-bold text-sauna-navy mb-1`}>
            {getInitials(title)}
          </div>
          <div className="text-xs text-sauna-orange font-medium">
            {subtitle || title}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PhotoPlaceholder; 